// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "seatsLegend__wrapper-3grS5";
export { _1 as "__esModule", _2 as "seatsLegend__wrapper" }
export default { "__esModule": _1, "seatsLegend__wrapper": _2 }
